import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldAlert, Gavel, Scale } from 'lucide-react';

const OPTIONS = [
  {
    value: 'impugnacao',
    title: 'Impugnação',
    description: 'Conteste cláusulas restritivas e ilegalidades do edital.',
    icon: ShieldAlert,
  },
  {
    value: 'recurso_administrativo',
    title: 'Recurso Administrativo',
    description: 'Reverta inabilitações e desclassificações com base técnica e jurídica.',
    icon: Gavel,
  },
  {
    value: 'contrarrazao',
    title: 'Contrarrazão',
    description: 'Refute ponto a ponto o recurso do concorrente.',
    icon: Scale,
  },
];

export default function ManifestoTypeSelector({ value, onChange, disabled = false }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Selecione o tipo de manifesto</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-3 md:grid-cols-3">
        {OPTIONS.map((opt) => {
          const Icon = opt.icon;
          const selected = value === opt.value;
          return (
            <Button
              key={opt.value}
              type="button"
              variant={selected ? 'default' : 'outline'}
              className="h-auto min-h-28 justify-start p-4 text-left"
              onClick={() => onChange(opt.value)}
              disabled={disabled}
            >
              <span className="flex items-start gap-3">
                <Icon className="h-5 w-5 shrink-0 mt-0.5" />
                <span>
                  <span className="block font-semibold">{opt.title}</span>
                  <span className="block text-xs opacity-80 mt-1 whitespace-normal">{opt.description}</span>
                </span>
              </span>
            </Button>
          );
        })}
      </CardContent>
    </Card>
  );
}
